// extracted by mini-css-extract-plugin
export default {"link":"style_link__9pBun","centerGrid":"style_centerGrid__OYVf6","img":"style_img__tGsoh","namegame":"style_namegame__Ylgph","center":"style_center__GKEiH"};